import * as React from 'react';
import { Stack, Pagination, PaginationItem } from '@mui/material';
import { useEffect } from 'react';
import axios from 'axios';
import { colors } from '../Theme/tokens';

// Simple text "icons" to replace the default arrow icons
const PreviousLabel = () => <>Previous</>;
const NextLabel = () => <>Next</>;

function CryptoTablePagination({ totalData, setCoins, searchValueRef, sort }) {
  const [page, setPage] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);

  useEffect(() => {
    setPage(0);
  }, [sort]);

  useEffect(() => {
    if (page == 0) {
      setPage(1);
    }
  }, [page]);

  const getRowsPerPageCoins = (num) => {
    axios
      .get(
        `https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&order=${sort}&per_page=${num}&page=1&sparkline=true&price_change_percentage=1h%2C%2024h%2C%207d`,
        { withCredentials: false }
      )
      .then((res) => {
        if (res.status === 200) {
          setCoins(res.data);
          searchValueRef.current.scrollIntoView({ behavior: 'smooth' });
        }
      });
  };

  const getPageChangeCoins = (pageNo) => {
    axios
      .get(
        `https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&order=${sort}&per_page=${rowsPerPage}&page=${pageNo}&sparkline=true&price_change_percentage=1h%2C%2024h%2C%207d`,
        { withCredentials: false }
      )
      .then((res) => {
        if (res.status === 200) {
          setCoins(res.data);
        }
      });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getPageChangeCoins(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    getRowsPerPageCoins(event.target.value);
    setPage(0);
  };

  return (
    <Stack mt={4} direction="row" justifyContent="center" spacing={2}>
      <Pagination
        count={parseInt(totalData / rowsPerPage)}
        page={page}
        onChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        variant="outlined"
        shape="rounded"
        slots={{ previous: PreviousLabel, next: NextLabel }}
        sx={{
          '.MuiPaginationItem-root': {
            borderRadius: '6px',
            backgroundColor: 'white',
            borderColor: '#e0e0e0',
            color: '#333',
            minWidth: '40px',
            height: '40px',
          },
          '.MuiPaginationItem-previousNext': {
            minWidth: 'auto',
            paddingLeft: '14px',
            paddingRight: '14px',
          },
          '.Mui-selected': {
            backgroundColor: `${colors.primary.main} !important`,
            color: 'white',
            borderColor: `${colors.primary.main} !important`,
          },
          '.Mui-selected:hover': {
            backgroundColor: colors.primary.main,
            color: 'white',
          },
          '.Mui-disabled': {
            opacity: 0.5,
          },
        }}
        renderItem={(item) => <PaginationItem {...item} />}
      />
    </Stack>
  );
}

export default React.memo(CryptoTablePagination);